/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const UploadFileDocument = gql`
    mutation UploadFile($file: String!, $fileName: String!, $fromDomain: String) {
  uploadFile(file: $file, fileName: $fileName, fromDomain: $fromDomain) {
    filePath
    fileName
    id
    fullFilePath
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      fileName: // value for 'fileName'
 *      fromDomain: // value for 'fromDomain'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const GetUserFilesDocument = gql`
    query GetUserFiles {
  user {
    id
    files {
      fileName
      id
      extension
      filePath
      size
    }
    activePremium
  }
}
    `;

/**
 * __useGetUserFilesQuery__
 *
 * To run a query within a React component, call `useGetUserFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
      }
export function useGetUserFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
        }
export function useGetUserFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFilesQuery, GetUserFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, options);
        }
export type GetUserFilesQueryHookResult = ReturnType<typeof useGetUserFilesQuery>;
export type GetUserFilesLazyQueryHookResult = ReturnType<typeof useGetUserFilesLazyQuery>;
export type GetUserFilesSuspenseQueryHookResult = ReturnType<typeof useGetUserFilesSuspenseQuery>;
export type GetUserFilesQueryResult = Apollo.QueryResult<GetUserFilesQuery, GetUserFilesQueryVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($id: Int!) {
  deleteFile(id: $id)
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const BindFileToPageDocument = gql`
    mutation BindFileToPage($pageId: Int!, $fileId: Int!) {
  bindFileToPage(pageId: $pageId, fileId: $fileId) {
    id
  }
}
    `;
export type BindFileToPageMutationFn = Apollo.MutationFunction<BindFileToPageMutation, BindFileToPageMutationVariables>;

/**
 * __useBindFileToPageMutation__
 *
 * To run a mutation, you first call `useBindFileToPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBindFileToPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bindFileToPageMutation, { data, loading, error }] = useBindFileToPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useBindFileToPageMutation(baseOptions?: Apollo.MutationHookOptions<BindFileToPageMutation, BindFileToPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BindFileToPageMutation, BindFileToPageMutationVariables>(BindFileToPageDocument, options);
      }
export type BindFileToPageMutationHookResult = ReturnType<typeof useBindFileToPageMutation>;
export type BindFileToPageMutationResult = Apollo.MutationResult<BindFileToPageMutation>;
export type BindFileToPageMutationOptions = Apollo.BaseMutationOptions<BindFileToPageMutation, BindFileToPageMutationVariables>;
export const MakeFilePreloaderDocument = gql`
    mutation MakeFilePreloader($fileId: Int!, $pageId: Int!) {
  makeFilePreloader(fileId: $fileId, pageId: $pageId) {
    id
  }
}
    `;
export type MakeFilePreloaderMutationFn = Apollo.MutationFunction<MakeFilePreloaderMutation, MakeFilePreloaderMutationVariables>;

/**
 * __useMakeFilePreloaderMutation__
 *
 * To run a mutation, you first call `useMakeFilePreloaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFilePreloaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFilePreloaderMutation, { data, loading, error }] = useMakeFilePreloaderMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useMakeFilePreloaderMutation(baseOptions?: Apollo.MutationHookOptions<MakeFilePreloaderMutation, MakeFilePreloaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeFilePreloaderMutation, MakeFilePreloaderMutationVariables>(MakeFilePreloaderDocument, options);
      }
export type MakeFilePreloaderMutationHookResult = ReturnType<typeof useMakeFilePreloaderMutation>;
export type MakeFilePreloaderMutationResult = Apollo.MutationResult<MakeFilePreloaderMutation>;
export type MakeFilePreloaderMutationOptions = Apollo.BaseMutationOptions<MakeFilePreloaderMutation, MakeFilePreloaderMutationVariables>;
export const DeletePreloaderFileDocument = gql`
    mutation DeletePreloaderFile($fileId: Int!, $pageId: Int!) {
  deletePreloaderFile(fileId: $fileId, pageId: $pageId) {
    id
  }
}
    `;
export type DeletePreloaderFileMutationFn = Apollo.MutationFunction<DeletePreloaderFileMutation, DeletePreloaderFileMutationVariables>;

/**
 * __useDeletePreloaderFileMutation__
 *
 * To run a mutation, you first call `useDeletePreloaderFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreloaderFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreloaderFileMutation, { data, loading, error }] = useDeletePreloaderFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePreloaderFileMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreloaderFileMutation, DeletePreloaderFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreloaderFileMutation, DeletePreloaderFileMutationVariables>(DeletePreloaderFileDocument, options);
      }
export type DeletePreloaderFileMutationHookResult = ReturnType<typeof useDeletePreloaderFileMutation>;
export type DeletePreloaderFileMutationResult = Apollo.MutationResult<DeletePreloaderFileMutation>;
export type DeletePreloaderFileMutationOptions = Apollo.BaseMutationOptions<DeletePreloaderFileMutation, DeletePreloaderFileMutationVariables>;
export type UploadFileMutationVariables = Types.Exact<{
  file: Types.Scalars['String']['input'];
  fileName: Types.Scalars['String']['input'];
  fromDomain?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'GraphFile', filePath: string, fileName: string, id?: number | null, fullFilePath: string } };

export type GetUserFilesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserFilesQuery = { __typename?: 'Query', user?: { __typename?: 'GraphUser', id?: number | null, activePremium: boolean, files: Array<{ __typename?: 'GraphFile', fileName: string, id?: number | null, extension: string, filePath: string, size?: number | null }> } | null };

export type DeleteFileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type BindFileToPageMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  fileId: Types.Scalars['Int']['input'];
}>;


export type BindFileToPageMutation = { __typename?: 'Mutation', bindFileToPage: { __typename?: 'GraphPage', id?: number | null } };

export type MakeFilePreloaderMutationVariables = Types.Exact<{
  fileId: Types.Scalars['Int']['input'];
  pageId: Types.Scalars['Int']['input'];
}>;


export type MakeFilePreloaderMutation = { __typename?: 'Mutation', makeFilePreloader: { __typename?: 'GraphPage', id?: number | null } };

export type DeletePreloaderFileMutationVariables = Types.Exact<{
  fileId: Types.Scalars['Int']['input'];
  pageId: Types.Scalars['Int']['input'];
}>;


export type DeletePreloaderFileMutation = { __typename?: 'Mutation', deletePreloaderFile: { __typename?: 'GraphPage', id?: number | null } };
